import 'mutationobserver-shim'; // 必须在其他代码前引入
import { createApp } from 'vue'
import router from './router';
import App from './App.vue'
import 'animate.css'; // 确保引入动画样式库
// import 'animate.css';

// createApp(App).mount('#app')
const app = createApp(App);
app.use(router);
app.mount('#app');
